export default __webpack_public_path__ + "static/media/Image4.1613a3c0.png";